import productCardConfig from "@ui/components/article/ProductCard/config/ProductCard.theverge.config";
import shareButtonsConfig from "@ui/components/article/ShareButtons/config/ShareButtons.theverge.config";
import notificationSettingsConfig from "@ui/components/auth/account/NotificationSettings/config/NotificationSettings.theverge.config";
import overtoneComponentConfig from "@ui/components/brand/overtone/config/component.config";
import checkoutConfirmationConfig from "@ui/components/checkout/CheckoutConfirmation/config/CheckoutConfirmation.theverge.config";
import subscriptionCollageConfig from "@ui/components/checkout/SubscriptionCollage/config/SubscriptionCollage.theverge.config";
import compactContentCardConfig from "@ui/components/content-cards/CompactContentCard/config/CompactContentCard.theverge.config";
import contentBlockBylineConfig from "@ui/components/content-cards/ContentBlock/components/ContentBlockByline/config/ContentBlockByline.theverge.config";
import contentBlockMetaConfig from "@ui/components/content-cards/ContentBlock/components/ContentBlockMeta/config/ContentBlockMeta.theverge.config";
import contentCardScoreConfig from "@ui/components/content-cards/ContentCardScore/config/ContentCardScore.theverge.config";
import prominentContentCardConfig from "@ui/components/content-cards/ProminentContentCard/config/ProminentContentCard.theverge.config";
import quickPostConfig from "@ui/components/content-cards/QuickPost/config/QuickPost.theverge.config";
import contactFormConfig from "@ui/components/cta/ContactForm/config/ContactForm.theverge.config";
import newsletterConfig from "@ui/components/cta/Newsletter/config/Newsletter.theverge.config";
import headerPatternConfig from "@ui/components/layout/HeaderPattern/config/HeaderPattern.theverge.config";
import pageHeaderConfig from "@ui/components/layout/PageHeader/config/PageHeader.theverge.config";
import riverConfig from "@ui/components/layout/River/config/River.theverge.config";
import disclaimerConfig from "@ui/components/ledes/Disclaimer/config/Disclaimer.theverge.config";
import ledeMetaConfig from "@ui/components/ledes/LedeMeta/config/LedeMeta.theverge.config";
import standardLedeConfig from "@ui/components/ledes/StandardLede/config/StandardLede.theverge.config";
import imageSliderConfig from "@ui/components/media/ImageSlider/config/ImageSlider.theverge.config";
import metaCategoryConfig from "@ui/components/meta/Category/config/Category.theverge.config";
import metaCommentCountConfig from "@ui/components/meta/CommentCount/config/CommmentCount.theverge.config";
import footerConfig from "@ui/components/navigation/Footer/config/Footer.theverge.config";
import navigationConfig from "@ui/components/navigation/Navigation/config/Navigation.theverge.config";
import socialLinksConfig from "@ui/components/navigation/SocialLinks/config/SocialLinks.theverge.config";
import notificationsListConfig from "@ui/components/notifications/NotificationsList/config/NotificationsList.theverge.config";
import articleRecircConfig from "@ui/components/recirculation/ArticleRecirc/config/ArticleRecirc.theverge.config";
import mostPopularListConfig from "@ui/components/recirculation/MostPopularList/config/MostPopularList.theverge.config";
import { ComponentConfigs } from "@ui/context/component-config-context";
import { mergeProps } from "@ui/utils/merge-props";

const componentConfig: ComponentConfigs = mergeProps(overtoneComponentConfig, {
  overtoneComponentConfig,
  checkoutConfirmation: checkoutConfirmationConfig,
  compactContentCard: compactContentCardConfig,
  contactForm: contactFormConfig,
  footer: footerConfig,
  navigation: navigationConfig,
  disclaimer: disclaimerConfig,
  ledeMeta: ledeMetaConfig,
  socialLinks: socialLinksConfig,
  metaCategory: metaCategoryConfig,
  standardLede: standardLedeConfig,
  contentBlockMeta: contentBlockMetaConfig,
  imageSlider: imageSliderConfig,
  headerPattern: headerPatternConfig,
  shareButtons: shareButtonsConfig,
  pageHeader: pageHeaderConfig,
  river: riverConfig,
  articleRecirc: articleRecircConfig,
  quickPost: quickPostConfig,
  prominentContentCard: prominentContentCardConfig,
  contentBlockByline: contentBlockBylineConfig,
  mostPopularList: mostPopularListConfig,
  productCard: productCardConfig,
  contentCardScore: contentCardScoreConfig,
  newsletter: newsletterConfig,
  subscriptionCollage: subscriptionCollageConfig,
  metaCommentCount: metaCommentCountConfig,
  notificationsList: notificationsListConfig,
  notificationSettings: notificationSettingsConfig,
});

export default componentConfig;
